import React, { useRef } from "react";
import { Box, Card } from "@curves/ui-base";
import useEChart from "@util/hook/useEChart";
import ChartSkeletonLoading from "@icoach/dashboard/ChartSkeletonLoading";

/********* 會員年資 *********/
const MemberAgeInClub = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			axis: {
				labels: ["6 個月", "7月~2年", "3~4 年", "5~10 年", "10 年以上"],
			},
			series: { data: [45, 180, 95, 40, 12] },
		},
	} = props;
	const { axis = {}, series = {} } = sourceData;
	const axisLabels = axis?.labels ?? [];
	const seriesData = series?.data ?? [];
	const isLoading = seriesData.length === 0;
	const title = "會員年資";
	const subTitle = "會籍持續時間分佈";
	const rawMax = Math.max(...seriesData);
	const niceMax = Math.ceil(rawMax / 50) * 50;

	const option = {
		title: {
			text: title,
			subtext: subTitle,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
			subtextStyle: {
				fontSize: 14,
				color: "#64748B",
				padding: [8, 0, 0, 0],
			},
		},
		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "shadow",
			},
			formatter: params => {
				const item = params[0];
				return `${item.name}<br/>${item.marker} ${item.value} 人`;
			},
		},

		grid: {
			left: 80,
			right: 40,
			top: 100,
			bottom: 50,
		},

		xAxis: [
			{
				type: "value",
				min: 0,
				max: niceMax,
				splitNumber: 5,
				axisLabel: { show: false },
				axisTick: { show: false },
				axisLine: { show: false },
				splitLine: {
					lineStyle: {
						type: "dashed",
						color: "#E5E7EB",
					},
				},
			},
		],
		yAxis: [
			{
				type: "category",
				inverse: true,
				data: axisLabels,
				axisTick: { show: false },
				axisLine: { show: false },
				axisLabel: {
					fontSize: 14,
					color: "#374151",
					margin: 10,
				},
			},
		],
		series: [
			{
				name: "Value",
				type: "bar",
				barWidth: "60%",
				data: seriesData,
				itemStyle: {
					color: "#5B0F74",
					borderRadius: [0, 6, 6, 0],
				},
			},
		],
	};

	useEChart(chartDomRef, option);

	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});

export default MemberAgeInClub;
